// Module
var code = `<form name="\$ctrl.form">
  <custom-fee
    fee-definition="\$ctrl.fee"
    branches="\$ctrl.branches"
    product-group="\$ctrl.productGroup"
    product-config="\$ctrl.productConfig"
    all-fee-definitions="\$ctrl.allFeeDefinitions"
    loan-insurance-accounts="\$ctrl.insuranceAccounts">
  </custom-fee>

  <div class="buttons">
    <button
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.cancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.save()">
      Save fee
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/charge/custom-fee-edit.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;